
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.321 16.004V5.75h1.358v10.254l3.162-3.064a.694.694 0 01.96 0 .643.643 0 010 .93l-4.321 4.187a.694.694 0 01-.96 0L7.199 13.87a.643.643 0 010-.93.694.694 0 01.96 0l3.162 3.064z","fill-rule":"nonzero"}})])
          )
        }
      }
    